import $ from 'jquery';
import moment from 'moment';
window.moment = moment;
//import 'bootstrap';
import 'bootstrap/dist/js/bootstrap.bundle.min.js'
import 'datatables.net'
import 'datatables.net-responsive'
import 'datatables.net-responsive-bs'
//import 'jquery-ui/ui/widgets/tabs.js';
$(document).ready(function () {

    //PILLS
    $('#pills-tab a').click(function (e) {
        e.preventDefault();
        e.stopImmediatePropagation();
        $(this).tab('show');
    });
    $("ul.nav-pills > li > a").on("shown.bs.tab",
        function (e) {
            var id = $(e.target).attr("href").substr(1);
            window.location.hash = id;
            $(window).scrollTop(0);
        });

    var hash = window.location.hash;
    $('#pills-tab a[href="' + hash + '"]').tab('show');
     
    //MESSAGES
    $('#inboxmessagetable').on('click', 'tbody tr td:not(:first-child)', function (evt) {
        var url = $(this).parent().data('messageurl');
        window.location.href = url;
    });

    //SETTINGS
    var $rows = $('#account-list-table tr');

    $('#accountEmail').val($('#js-selected-account').val());

    $('#js-selected-account').on('change',
        function () {
            var $this = $(this);
            $.each($rows,
                function (index, element) {
                    var $row = $(element);

                    if ($row.data('admin-email') !== $this.val()) {
                        $row.hide();
                    } else {
                        $row.show();
                    }
                });
            $('#accountEmail').val($(this).val());
        });

    //Notification
    var $setNotification = $('#update-notification-interval');
    $setNotification.on('submit', function (ev) {

        // Stopping default
        ev.preventDefault();

        // Building the form data
        var formData = $(this).serialize();

        // Do ajax request 
        $.ajax({
            data: formData,
            url: $setNotification.attr('action'),
            method: $setNotification.attr('method'),
            processData: false,
            success: function (response) {
                $("#notification-success").removeClass('d-none').slideDown(250).delay(1000).slideUp(250);
            },
            error: function (response) {
                $("#notification-error").removeClass('d-none').slideDown(250).delay(1000).slideUp(250);
            }
        });
    });
    var $addAccount = $('#add-inbox-account-form');
    $addAccount.on('validated', function (ev) {

        // Building the form data
        var formData = $(this).serialize();

        // Do ajax request 
        $.ajax({
            data: formData,
            url: $addAccount.attr('action'),
            method: $addAccount.attr('method'),
            processData: false,
            success: function (response) {
                $('#addAccount').modal('hide');
                location.reload(true);
            },
            error: function (response) {
                $('#addAccount').modal('hide');
                $("#add-account-error").removeClass('d-none').slideDown(250).delay(1000).slideUp(250);
            }
        });
     });
    //RENDER DATATABLE
    if ($('.block-inboxheader').length > 0) {
        $.fn.dataTable.render.ellipsis = function () {
            if ($(window).width() > 1200) {
                return function (data, type, row) {
                    return type === 'display' && data.length > 85 ? data.substr(0, 85) + '…' : data;

                };
            }
            if ($(window).width() < 1199 && $(window).width() > 993) {
                return function (data, type, row) {
                    return type === 'display' && data.length > 65 ? data.substr(0, 65) + '…' : data;

                };
            }
            if ($(window).width() < 992 && $(window).width() > 768) {
                return function (data, type, row) {
                    return type === 'display' && data.length > 75 ? data.substr(0, 75) + '…' : data;

                };
            }
            if ($(window).width() < 600) {
                return function (data, type, row) {
                    return type === 'display' && data.length > 35 ? data.substr(0, 35) + '…' : data;
                };
            }
        };

        $.fn.dataTable.ext.classes.sPageButton = 'pagination__item';
        var it = $('#inboxmessagetable').DataTable({
            "processing": true,
            "serverSide": true,
            "responsive": false,
            "lengthChange": false,
            "autoWidth": false,
            "pagingType": "numbers",

            "ajax": {
                "url": window.location.href + "/GetInboxPageMessages",
                "type": "POST",
                "dataType": "json",
            },
            "columns": [
                {
                    "data": "Created",
                    render: function(data, type, row){
                        if(type === "sort" || type === "type"){
                            return data;
                        }
                        return moment(data).format("YYYY-MM-DD");
                    },
                    "className": "date"
                },
                {
                    "data": "From" ,
                    "className": "sender"
                },
                {
                    "data": "Subject" ,
                    "className": "message",
                }
            ],
            columnDefs: [ {
            },
                {
                    targets: 2,
                    render: $.fn.dataTable.render.ellipsis(),
                    createdCell: function (td, data, rowData, row, col) {
                        if (rowData.AttachmentList.length > 0) {
                            $(td).append('<i class="fas fa-paperclip"></i>');
                        }
                        $(td).wrapInner('<div class="message-subject"/>');
                    }
                },
            ],

            select: {
                style:    'os',
                selector: 'td:first-child'
            },
            "createdRow": function (row, data, dataIndex) {
                if (data.State === "UNREAD") {
                    $(row).addClass('newmessage');
                }
                $(row).attr('data-messageurl', '?id=' + data.Id);
            },
            order: [[1, 'desc']],
            "language": {
                "zeroRecords": "Inga mail tillgängliga",
                "processing": "Hämtar meddelanden..."
            },
            "initComplete": function (settings, json) {
                $('#inboxmessagetable_wrapper').removeClass('form-inline');
                $('#inboxmessagetable_wrapper .col-sm-5').removeClass('col-sm-5');

                $('#inboxmessagetable').fadeIn(1000, function () {
                    $('#inboxmessagetable_wrapper').removeClass('form-inline');
                    $('#inboxmessagetable_wrapper .col-sm-5').removeClass('col-sm-5');
                });
            }
        });

        $('#length_change').val(it.page.len());
        $('#length_change').change(function () {
            it.page.len($(this).val()).draw();
        });
    }
});  